"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHORT_ID_LENGTH = exports.SHORT_ID_CHARS = void 0;
// Chatset of uppercase letters and numbers to avoid confusion with similar-looking characters (e.g., O and 0).
exports.SHORT_ID_CHARS = "123456789ACDEFGHJKLMNPQRSTUVWXYZ";
exports.SHORT_ID_LENGTH = 6;
//# sourceMappingURL=short-id.constants.js.map